import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const FacebookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
  </svg>
);

const Footer = () => {
  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/bureau', label: 'Bureau' },
    { path: '/activites', label: 'Activités' },
    { path: '/a-propos', label: 'À propos' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-column footer-brand">
          <span className="footer-logo">ASB</span>
          <p className="footer-tagline">
            Association des Scolaires Burkinabés au Sénégal
          </p>
          <p className="footer-motto">La Patrie ou la mort, nous vaincrons </p>
        </div>

        <div className="footer-column">
          <h4>Navigation</h4>
          <ul className="footer-links">
            {navLinks.map((link) => (
              <li key={link.path}>
                <Link to={link.path}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-column">
          <h4>Contact</h4>
          <p className="footer-location">Dakar, Sénégal</p>
          <a
            href="https://www.facebook.com/100064881242080/posts/pfbid0vYhtATuUeWBJhrYb8ng6iDNRF4xYAAW6MQCru2woarXFRie5DRSpzH3p633fztg1l/?app=fbl"
            className="footer-social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookIcon />
            <span>Suivez nos activités</span>
          </a>
        </div>
      </div>

      <div className="footer-divider"></div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} ASB — Tous droits réservés</p>
      </div>
    </footer>
  );
};

export default Footer;
